var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"tips","mode":"in-out"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tipShow),expression:"tipShow"}],staticClass:"tips"},[_c('svg-icon',{attrs:{"icon-class":"del"}}),_c('span',[_vm._v(_vm._s(_vm.tips))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c515611","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tips.vue
// module id = null
// module chunks = 